export enum EBoneType {
    Hob = 1,
    Sink,
    Tap,
    Hood,
    Oven,
    Dishwasher,
    WashingMachine,
    Fridge,
    Handle
}

export function isAperture(boneType: EBoneType): boolean {
    switch (boneType) {
        case EBoneType.Oven:
        case EBoneType.Dishwasher:
        case EBoneType.WashingMachine:
        case EBoneType.Fridge:
            return true;
        default:
            return false;
    }
}
